import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Route, Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Store} from "@ngrx/store";
import {ToastrService} from "ngx-toastr";
import {IBusinessUnit} from "../modules/business-units/models";
import {BusinessUnitService} from "../modules/business-units/services";
import {UtilService} from "../modules/shared/services";
import {AuthService} from "../services";
import {updateBusinessUnits, updateSelectedBusinessUnit} from "../modules/redux";
import { DataService } from '../services/data/data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, concatWith, map, Observable, of, switchMap, tap } from 'rxjs';
import { LoginResponseModel } from '../models/i-app-user';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private util: UtilService,
    private auth: AuthService,
    private store: Store,
    private dataService: DataService,
    private router: Router,
    private toastr: ToastrService,
    private businessUnitService: BusinessUnitService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {

    var loginUrl = this.router.createUrlTree(['auth', 'login'], { queryParams: { action: 'redirect', redirectUrl: state.url.toString() }});
    let businessUnitSlug = route.paramMap.get('id') || '';
   
    return this.auth.ValidateAndRefreshToken().pipe(
      switchMap((valid: boolean) => {

        if (valid == false) {
          this.toastr.error("Please login to access this page.", "Unauthorized");
          return of(loginUrl);
        }

        return this.businessUnitService.getUserBusinessUnits().pipe(
          map((businessUnits: IBusinessUnit[]) => {
            if (businessUnits.length == 0) {
              this.toastr.error("You don't have any business units.  Please contact admin.");
              return loginUrl;
            }
        
            this.dataService.businessUnits = businessUnits;

            this.store.dispatch(updateBusinessUnits({businessUnits: businessUnits}));

            // does the list of BUs include the slug that is being requested?
            var selectedBusinessUnitBySlug = businessUnits.filter(x => x.slug.toLowerCase() == businessUnitSlug.toLowerCase());

            if (selectedBusinessUnitBySlug.length == 0) {
              this.toastr.error("Error accessing this business unit.", "Unauthorized");
              return this.router.createUrlTree(['not-found']);
              // return loginUrl;
            }

            // you have access to the business unit
            var businessUnit = selectedBusinessUnitBySlug[0];
            // console.log("Current Business unit is ", businessUnit);

            this.dataService.currentBusinessUnit = businessUnit;
            this.store.dispatch(updateSelectedBusinessUnit({businessUnit}));

            return true;
          }),
        )
      }),
     
      catchError((err: HttpErrorResponse) => {
        console.error("Error validating token or getting business units", err); 
        this.toastr.error("An error occurred while verifying your access. Please try again.", "Error");
        return of(loginUrl);
      })
    );
  }
}

    // // check if the token is refreshable, if so refresh it and then get the business units, otherwise send to login
    // return this.auth.RefreshToken().pipe(
    //   switchMap((tokenResponse: LoginResponseModel) => {
        
    //     // console.log("----------> auth guard token refresh response", tokenResponse); 

    //     if (tokenResponse == null || tokenResponse.isSuccess == false) {
    //       this.toastr.error("Please login to access this page.", "Unauthorized");
    //       return of([]);
    //     }

    //     return this.businessUnitService.getUserBusinessUnits();
    //   }),
    //   map((businessUnits: IBusinessUnit[]) => {

    //     // console.log("----------> auth guard business units", businessUnits);

    //     if (businessUnits.length == 0) {
    //       return false;
    //     }
        
    //     this.dataService.businessUnits = businessUnits;

    //     this.store.dispatch(updateBusinessUnits({businessUnits: businessUnits}));

    //     // does the list of BUs include the slug that is being requested?
    //     var selectedBusinessUnitBySlug = businessUnits.filter(x => x.slug.toLowerCase() == businessUnitSlug.toLowerCase());

    //     if (selectedBusinessUnitBySlug.length == 0) {
    //       this.toastr.error("Error accessing this business unit.", "Unauthorized");
    //       return loginUrl;
    //     }

    //     // you have access to the business unit
    //     var businessUnit = selectedBusinessUnitBySlug[0];
    //     // console.log("Current Business unit is ", businessUnit);

    //     this.dataService.currentBusinessUnit = businessUnit;
    //     this.store.dispatch(updateSelectedBusinessUnit({businessUnit}));

    //     return true;
    //   }),
    //   catchError((err: HttpErrorResponse) => {
    //     console.error("Error in auth guard", err);
    //     this.toastr.error("An error occurred while verifying your access. Please try again.", "Error");
    //     return of(loginUrl);
    //   })
    // );

    // return this.businessUnitService.getUserBusinessUnits().pipe(
    //   map((businessUnits: IBusinessUnit[]) => {
        
    //     this.dataService.businessUnits = businessUnits;

    //     this.store.dispatch(updateBusinessUnits({businessUnits: businessUnits}));

    //     // does the list of BUs include the slug that is being requested?
    //     var bu = businessUnits.filter(x => x.slug.toLowerCase() == businessUnitSlug.toLowerCase());

    //     if (bu.length == 0) {
    //       this.toastr.error("Please login to access this page.", "Unauthorized");
    //       return loginUrl;
    //     }

    //     // you have access to the business unit
    //     var businessUnit = bu[0];
    //     console.log("Current Business unit is ", businessUnit);

    //     this.dataService.currentBusinessUnit = businessUnit;
    //     this.store.dispatch(updateSelectedBusinessUnit({businessUnit}));

    //     return true;
    //   })
    // );


//   canActivate1(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
//     console.log("Running auth guard!");
//     // check the validation of the cognito session
//     return new Promise<boolean | UrlTree>((resolve) => {

//       if (this.auth.IsLoggedIn() == false) {
//         // this.util.setRedirectPath(state.url.toString());
//         // this.util.logOutWithRedirect(state.url.toString()).then(() => {
//         //   this.toastr.error("Please login to access this page.", "Unauthorized");
//         // });

//         this.toastr.error("Please login to access this page.", "Unauthorized");
//         resolve(this.router.createUrlTree(['auth', 'login'], { queryParams: { action: 'redirect', url: state.url.toString() }}))
//         return;
//       }

//       let businessUnitSlug = route.paramMap.get('id') || '';

//       const specials = /[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]/g;
//       if (specials.test(businessUnitSlug) == true) {
//         console.log("Business Unit Slug has special characters", businessUnitSlug)
//         this.toastr.error("There is an issue with the Business Unit Name");
//         this.util.logOut();
//         resolve(this.router.createUrlTree([this.auth.LOGIN_ROUTE]));
//         return;
//       };

//       this.businessUnitService.getUserBusinessUnits().subscribe({
//         next: (businessUnits: IBusinessUnit[]) => { 
//           // console.log("business units", businessUnits);
//           this.dataService.businessUnits = businessUnits;

//           // if there are no business units, then log the user out
//           if (businessUnits.length == 0) {
//             this.toastr.error("You don't have any business units.  Please contact admin.");
//             this.util.logOut().then(() => console.log("Logged out!!!"));
//             resolve(this.router.createUrlTree([this.auth.LOGIN_ROUTE]));
//             return;
//           }

//           // console.log("business units length > 1", businessUnitSlug);
//           this.store.dispatch(updateBusinessUnits({businessUnits: businessUnits}));
          
//           // does the list of BUs include the slug that is being requested?
//           var bu = businessUnits.filter(x => x.slug.toLowerCase() == businessUnitSlug.toLowerCase());

//           if (bu.length == 0) {
//             this.toastr.error(`You don't have access to the '${businessUnitSlug}' business unit.  Please contact admin.`);
//             this.util.logOut().then(() => console.log("Logged out!!!"));
//             resolve(this.router.createUrlTree([this.auth.LOGIN_ROUTE]));
//             return;
//           }

//           // you have access to the business unit
//           var businessUnit = bu[0];
//           console.log("Current Business unit is ", businessUnit);

//           this.dataService.currentBusinessUnit = businessUnit;
//           this.store.dispatch(updateSelectedBusinessUnit({businessUnit}));


//           resolve(true)
//         },
//         error: (err: HttpErrorResponse) => {
//           console.error("Error getting business units for user", err);
//           this.util.sendUserToErrorPage("Something went wrong!");
//         }
//       });
//     });
//   }
// }
